import { LoanCaseDTO } from "@smartx/mikro-vt-client-api"
import { useTranslation } from "react-i18next"
import { IField } from "../../../components/DataList/DataList"
import * as caseHelper from "../../../functions/caseHelper"
import { DataListComponent } from "../../../Shared"
import { VALUE_LIST_ENUM } from "../../../functions/setCodeTableValues"
import { isBianco } from "../../../functions/helpers"

interface IOverviewStatusProps {
  loanCaseData: LoanCaseDTO
}

const OverviewStatus: React.FC<IOverviewStatusProps> = ({ loanCaseData }) => {
  const { t } = useTranslation()

  const fieldArr: Array<IField> = [
    isBianco(loanCaseData?.productCode)
      ? {
          label: t("case.fields.productCode"),
          value: loanCaseData?.productInstances?.find((el) => !!el)
            ?.subProductName,
          fieldType: "text",
        }
      : {
          label: t("case.fields.productCode"),
          value: loanCaseData.productCode,
          fieldType: "CVT",
          list: VALUE_LIST_ENUM.ProductList,
        },
    {
      label: t("case.fields.loanCaseStatus"),
      value: caseHelper.getStatusName(loanCaseData.loanCaseStatus),
      fieldType: "text",
    },
    {
      label: t("case.fields.cjkNumber"),
      value: loanCaseData.cjkNumber,
      fieldType: "text",
    },
    {
      label: t("case.fields.salesRepresentativeName"),
      value: loanCaseData.salesRepresentativeName,
      fieldType: "text",
    },
    {
      label: t("case.fields.branchName"),
      value: loanCaseData.branchName,
      fieldType: "text",
    },
    {
      label: t("case.fields.branchAddress"),
      value: loanCaseData.branchAddress,
      fieldType: "text",
    },
  ]

  return <DataListComponent dataList={fieldArr} />
}

export default OverviewStatus
